import {globalWindow} from '../../libs/shared/core/src/helpers/browser/browserHelpers';
import {CancelToken} from '../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {
  delayAsync as defaultDelayAsync,
  TimeoutCallback,
  withTimeoutAsync as defaultWithTimeoutAsync,
} from '../../libs/shared/core/src/helpers/utilities/asyncHelpers';

export function delayAsync(delay: number = 0, cancelToken?: CancelToken): Promise<void> {
  return defaultDelayAsync(globalWindow, delay, cancelToken);
}

/*
 * Timeout.
 */

export async function withTimeoutAsync<T>(
  callback: () => Promise<T>,
  timeout: number,
  timeoutCallback?: TimeoutCallback<T>,
): Promise<T> {
  return defaultWithTimeoutAsync(globalWindow, callback, timeout, timeoutCallback);
}

/*
 * Jitter.
 */

/** Jitters the given delay. A jitter factor of 0 means no jitter, 1 means full jitter. */
export function computeDelayWithJitter(delay: number, jitterWeight: number): number {
  if (jitterWeight < 0 || jitterWeight > 1) {
    throw new Error('Invalid jitter factor');
  }

  const nonJitterWeight = 1 - jitterWeight;
  const jitter = Math.random();

  return nonJitterWeight * delay + jitterWeight * delay * jitter;
}

export function delayWithJitterAsync(delay: number, jitterWeight: number, cancelToken?: CancelToken) {
  return delayAsync(computeDelayWithJitter(delay, jitterWeight), cancelToken);
}
